var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"myChart",attrs:{"id":"myChart","width":"400","height":"200"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }